export class AnalyticStore
{
  private static user_id: string;
  private static session_id: string;
  private static session_id_serv?: string;

  public static init(user_id: string)
  {
    this.user_id = user_id;
    this.session_id = makeSessionId();
    this.session_id_serv = undefined;
  }

  public static setUserId( user_id: string )
  {
    this.user_id = user_id;
  }

  public static getUserId(): string
  {
    return this.user_id;
  }

  public static setSessionId( session_id: string )
  {
    this.session_id = session_id;
  }

  public static getSessionId(): string
  {
    return this.session_id;
  }

  public static setSessionIdFromServer( session_id_serv: string )
  {
    this.session_id_serv = session_id_serv;
  }

  public static getSessionIdFromServer(): string | undefined
  {
    return this.session_id_serv ?? '';
  }
}

const makeSessionId = (): string =>
{
  try
  {
    const any_crypto = ( globalThis as { crypto?: Crypto } ).crypto;
    const uuid = any_crypto?.randomUUID?.();
    if ( uuid ) return uuid;
  } catch {}

  return `${Date.now()}_${Math.random().toString( 16 ).slice( 2 )}`;
};
